import router from "./router.js";
import Cookies from "js-cookie";
import { getQueryObject } from "./filters/index.js";
import { Message } from "element-ui";
import Comjs from "@/assets/js/common.js";

const whiteList = ["/login", "/authRedirect", "/casLogin"]; // no redirect whitelist
router.beforeEach((to, from, next) => {
  // console.log(to, "to====");
  const token = Cookies.get("Dealer-User-Token");
  if (token) {
    next();
  } else {
    if (location.search) {
      const search = getQueryObject(location.search);
      if (search.code) {
        if (to.path != "/authRedirect" && to.path !== "/casLogin") {
          next({
            path: "/authRedirect",
            replace: true,
            query: {
              logincode: search.code
            }
          });
        } else {
          next();
        }
      }
      return;
    }
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      Message({
        message: '登录过期',
        type: "error",
        duration: 3000
      });
      setTimeout(() => {
        Comjs.removeDealer();
        router.push("/login");
      }, 1500)
    }
  }
});
